import { LanguageSelectorSidebar } from "@/components/General/LanguageSelector/languageSelectorSidebar.container";
import { AccountLinks } from "@/components/Navigation/Sidebar/components/accountLinks/accountLinks";
import { Assortiment } from "@/components/Navigation/Sidebar/components/assortiment/assortiment";
import { InnerHtml } from "@/components/Navigation/Sidebar/components/innerHtml";
import { useSidebarContext } from "@/components/Navigation/Sidebar/context/sidebar.context";
import { Base } from "@/components/Navigation/Sidebar/sidebar.base";

export const Sidebar = Object.assign(Base, {
    useContext: useSidebarContext,
    Assortiment: Assortiment,
    InnerHtml: InnerHtml,
    AccountLinks: AccountLinks,
    LanguageSelector: LanguageSelectorSidebar
});
